<template>
    <div class="content">
        <div class="row">
            <div class="col-md-12">
                <a-card>
                    <form @submit.prevent="addData($event)">
                        <div class="row">
                            <div class="col-md-6 my-1">
                                <div class="form-group ">
                                    <label>نام</label>
                                    <input type="text" name="title" v-model="info.title" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-6 my-1">
                                <div class="form-group ">
                                    <label>آدرس  </label>
                                    <input type="text" name="link" v-model="info.link" class="form-control" />
                                </div>
                            </div>

                            <div class="col-md-6 my-1">
                                <div class="form-group ">
                                    <label class="sr-only" for="inline-form-input-name">  نوع بنر</label>
                                    <select name="type" class="form-control" v-model="info.type">
                                        <option value="">انتخاب</option>
                                        <option v-for="parent in types" :value="parent.id">{{ parent . title }}
                                        </option>

                                    </select>
                                </div>
                            </div>

                            <div class="col-md-6 my-1">
                                <div class="form-group ">
                                    <label>قیمت (ریال) </label>
                                    <input type="number" name="price" v-model="info.price" class="form-control" />
                                </div>
                            </div>
                           
                           
                            <div class="col-md-6 ">
                                <div class="form-group m-md-2">
                                    <label>آپلود  </label>

                                    <picture-input ref="pictureInput" width="300" height="200" margin="16"
                                        accept="image/jpeg,image/png" size="5" radius="5"
                                        :crop="false" :alertOnError="false" button-class="btn btn-success"
                                        @change="onChange(info.image)"
                                        :custom-strings="{
                                            upload: '<p>دستگاه شما از آپلود عکس پشتیبانی نمی کند</p>',
                                            drag: ' انتخاب عکس',
                                            tap: ' انتخاب عکس  ',
                                            change: 'تعویض عکس',
                                            remove: 'حذف عکس',
                                            select: 'انتخاب عکس',
                                            selected: '<p>عکس با موفقیت انتخاب شد</p>',
                                            fileSize: 'سایز فایل شما زیاد است',
                                            fileType: 'نوع فایل نا معتبر میباشد',
                                            aspect: 'Landscape/Portrait',
                                        }"
                                         id="image">
                                    </picture-input>
                                </div>
                            </div>
                            <div class="col-md-12 ">
                                <div class="form-group ">
                                    <label>توضیحات</label>
                                    <b-form-textarea name="description" id="textarea" v-model="info.description" placeholder="توضیحات ..."
                                        rows="3" max-rows="6"></b-form-textarea>
                                </div>
                            </div>
                            <hr class="mt-5">
                        </div>
                        <div class="card-footer  ">
                            <div class="row ">
                                <div class="col-md-10"></div>
                                <div class="col-md-1 ">
                                    <button type="submit" class="btn btn-fill btn-outline-success w-100">
                                        ذخیره
                                    </button>
                                </div>
                                <div class="col-md-1 ">
                                    <router-link to="/categories/list" class="btn btn-fill btn-outline-danger w-100">
                                        بازگشت</router-link>
                                </div>
                            </div>
                        </div>
                    </form>
                </a-card>
            </div>
        </div>
    </div>
</template>
<script>

import PictureInput from 'vue-picture-input';

    export default {
        components: {
            PictureInput,

        },
        data() {
            return {
                types:[],
                info: {
                },
              
            };
        },
        methods: {
            
            addData(event) {
                let _this = this;
                let data = new FormData(event.target);
                data.append("image", this.info.image);

                _this.$root.loading = true;
                axios
                    .post("/sliders/add", data)
                    .then(function(response) {
                        _this.$root.loading = false;
                        _this.$toast.success(" بنر با موفقیت افزوده شد");
                        _this.$router.push("/banners/list");
                    })
                    .catch(function(err) {
                        _this.$root.loading = false;
                        _this.$root.handleAxiosError(err);
                    });
            },
            onChange() {
                let _this = this;
                let formData = new FormData();
                formData.append("file", document.getElementById('image').files[0]);
                axios.post("/uploadImageSlider", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }).then(function(response) {
                        _this.info.image = response.data.path;
                        _this.$toast.success("عکس بنر با موفقیت ذخیره شد.   ");

                    })
                    .catch(function(err) {
                        _this.$toast.error("عکس ارسالی  صحیح  نیست.   ");
                        _this.$root.handleAxiosError(err);
                    });
            },
              async getTypes() {
                let _this = this;
                let url = '/sliders/setting';
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.types=response.data
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
        },
        mounted(){
            this.getTypes();
        }
    };
</script>
